// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"r9rowly5GpkGeUfusWAr3","Center":"_1uMlSl1xULKPG3ohGFJPZH","SpinnerBlade":"cRPVHRARmmSacD95HczOd","spinner-fade":"_1hA0L-Mdqu9QuqByCmuQuq"};